import { gql } from '@apollo/client';

export const CreateAgent = gql`
    mutation createAgent($phoneNumber: String!, $businessName: String!, $address: String!) {
        createAgent(phoneNumber: $phoneNumber, businessName: $businessName, address: $address) {
            success
            error
        }
    }
`;
